


















import { computed, defineComponent, ref, PropType } from "@vue/composition-api";
import { FundraisingGoalReward } from "@scrile/api-provider/dist/api/FundraisingGoalsProvider";
import { UserWithAvatar } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { handleRequestError } from "@/lib/handleRequestError";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString } from "@/lib/moneyHelpers";
import { NotificationData } from "@/types";
import { ERRORS, EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import FundraisingGoalRewardCard from "@/components/FundraisingGoal/FundraisingGoalRewardCard";

export default defineComponent({
  name: "RewardPurchaseModal",
  components: { BaseButton, FundraisingGoalRewardCard, BaseConfirm },
  props: {
    reward: { type: Object as PropType<FundraisingGoalReward | null> },
    rewardOwner: { type: Object as PropType<UserWithAvatar | null> },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const rewardPrice = computed(() => formatMoneyString(props.reward?.amount ?? 0));
    const buttonText = computed(() => $t("Pay {0} now", [rewardPrice.value]));

    const paymentDetails = computed(() => [
      { title: $t("Amount"), value: rewardPrice.value },
      { title: $t("Payment method"), value: $t("My balance") },
    ]);

    const onPurchase = useAuthorisedOnly(async () => {
      if (!props.reward) return;
      try {
        loading.value = true;
        providers.FundraisingGoalsProvider.setReceiveErrors(false);
        const response = await providers.FundraisingGoalsProvider.rewardPurchase({ id: props.reward.id });

        emit("purchased", response);

        emitter.emit<NotificationData>(EVENTS.NOTIFICATION_SHOW, {
          text: $t("Thank you! Creator will contact you to give you the reward"),
          image: { user: props.rewardOwner },
          button: { text: $t("Close") },
          position: "top",
        });
      } catch (e) {
        handleRequestError(e, [
          {
            comparator: e => e.details?.messageTemplate === ERRORS.SPENDING_BALANCE,
            onSuccessCB: () => emitter.emit(EVENTS.BALANCE_REFILL_SHOW),
          },
        ]);
      } finally {
        loading.value = false;
      }
    });

    return {
      loading,
      buttonText,
      paymentDetails,
      onPurchase,
    };
  },
});
